<template>
  <div v-show="!hidden">
    <q-tabs
      v-model="model"
      align="left"
      :class="alt ? 'custom-tabs' : 'bg-white text-dark'"
      dense
      :indicator-color="alt ? 'transparent' : 'primary'"
    >
      <q-tab
        v-for="item in this.data"
        :key="item[this.nameOption || 'name']"
        :name="item[this.nameOption || 'name']"
        :class="alt ? 'custom-tab' : ''"
      >
        <template v-if="item.icon">
          <span class="tw-inline-flex tw-items-center tw-gap-1.5">
            <SvgIcon v-if="item.customIcon" :name="item.icon" size="16px" :color="item.warning ? 'red' : 'currentColor'" />
            <q-icon v-else :name="item.icon" size="18px" />
            <span>{{ item[this.labelOption || 'label'] }}</span>
            <span v-if="item.badge != null && item.badge > 0" class="custom-tab-badge">{{ item.badge }}</span>
          </span>
        </template>
        <template v-else>
          <span class="tw-inline-flex tw-items-center tw-gap-2">
            <span>{{ item[this.labelOption || 'label'] }}</span>
            <span v-if="item.badge != null && item.badge > 0" class="custom-tab-badge">{{ item.badge }}</span>
          </span>
        </template>
      </q-tab>
    </q-tabs>
    <q-tab-panels v-model="model" animated>
      <CustomTabPanel
        v-for="item in this.data"
        :name="item[this.nameOption || 'name']"
        :class="{'paddingless': paddingless }"
        :paddingless="paddingless"
      >
        <slot :data="item"></slot>
      </CustomTabPanel>
    </q-tab-panels>
  </div>
</template>

<script>
import CustomTabPanel from "@/components/common/CustomTabs/CustomTabPanel";
import SvgIcon from '@/components/common/SvgIcon';

export default {
  name: "CustomTabs",
  components: {CustomTabPanel, SvgIcon},
  props: {
    labelOption: String,
    nameOption: String,
    tab: String,
    data: Array,
    hidden: Boolean,
    alt: Boolean,
    paddingless: Boolean,
  },
  computed: {
    model: {
      get() {
        return this.tab;
      },
      set(newValue) {
        this.$emit("change_tab", newValue);
      },
    },
  },
}
</script>

<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;
.custom-tabs {
  width: fit-content;
  background: transparent;

  :deep(.q-tabs__content) {
    gap: 0;
    background-color: #EEEEEE;
    padding: 3px;
    border-radius: 8px;
    width: fit-content;
  }
}

.custom-tab {
  background-color: #EEEEEE;
  color: #9298A2;
  border-radius: 6px;
  font-weight: 500;
  min-height: 36px;
  padding: 0 10px;

  &.q-tab--active {
    background-color: $primary-light;
    color: white;
  }

  :deep(.q-tab__label) {
    text-transform: none;
    font-weight: 400;
    font-size: 14px;
  }

  :deep(.q-tab__content) {
    padding: 4px 12px;
  }
}

.custom-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 50%;
  background-color: #ef4444;
  color: white;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}
</style>
